import axios from "axios";
import store from '@/store'
import router from '../router'
import { Message } from "element-ui";
import setting from '../setting'

const service = axios.create({
  baseURL: setting.ADMINURL,
  timeout: 30000, // request timeout
});

const arr = [
  '/quality_of_voice_public/list', 
  '/quality_of_voice_public/',
  '/sys_application_public/list', 
  '/language_public/code/listAll', 
  '/notice_affiche_public/list'
];

const tokenArray = [
  '/auth/verify_token', 
  '/sys_entry/list', 
  '/file_center/list', 
  '/sys_todo/list', 
  '/sys_entry', 
  '/auth/profile', 
  '/auth/logout', 
  '/sys_staff', 
  '/sys_staff/password', 
  '/sys_staff/update_lang_code'
];

service.interceptors.request.use(
  config => {
    const data = {
      signature: "303f021e08a46c7b14bce0cc0ca65f60def8e78f771fb740f189329ac3c89e9e323b021d69506160d8b7f0d03f769b93a32b357284e8a3530a5bae8a754f613699",
      timestamp: Date.now(),
    };

    const PRIVATE_KEY = 'F5934C14C0F0193CA1D0344AF9C99739'

    const CryptoJS = require("crypto-js");

    tokenArray.forEach(item => {

      if (item == config.url) {
        config.headers["Authorization"] = "Bearer " + sessionStorage.getItem("access_token")
      }

      if (item == config.url.split('?')[0]) {
        config.headers["Authorization"] = "Bearer " + sessionStorage.getItem("access_token")
      }
    })
    
    arr.forEach(item => {
      if (item == config.url.split('?')[0]) {
        config.headers["Authorization"] = CryptoJS.AES.encrypt(JSON.stringify(data), PRIVATE_KEY).toString()
      }

      if (item == config.url) {
        config.headers["Authorization"] = CryptoJS.AES.encrypt(JSON.stringify(data), PRIVATE_KEY).toString()
      }

      if(config.url.indexOf(item) >= 0) {
        config.headers["Authorization"] = CryptoJS.AES.encrypt(JSON.stringify(data), PRIVATE_KEY).toString()
      }
    })

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    const res = response.data;

    if (res.message == '内部服务器错误' && response.status == 200) {
      Message({
        message: res.message,
        type: "error",
        duration: 5 * 1000
      });
      return res
    }

    if (response.status == 401) {
      Message({
        message: 'token令牌失效',
        type: "error",
        duration: 5 * 1000
      });
      router.push('/')
    }


    if (response.status == 500) {
      Message({
        message: res.message,
        type: "error",
        duration: 5 * 1000
      });
      return res
    }


    if (response.status == -1) {
      Message({
        message: res.message,
        type: "error",
        duration: 5 * 1000
      });
    }

    return res

  },
  error => {
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;

